import { MCBLS020InitRequest } from 'types/MCBLS020/MCBLS020InitRequest'
import { MCBLS020OutputPdfRequest } from 'types/MCBLS020/MCBLS020OutputPdfRequest'
import { MCBQS030InitRequest } from 'types/MCBQS030/MCBQS030InitRequest'
import { MCBQS030OutputPdfRequest } from 'types/MCBQS030/MCBQS030OutputPdfRequest'
import request from 'utils/request'

export const initRequest = (apidata: MCBQS030InitRequest) =>
  request({
    url: `/MCBQS030/init`,
    method: 'post',
    data: apidata,
  })

export const downloadApi = (apidata: MCBQS030OutputPdfRequest) =>
  request({
    url: '/MCBQS030/download',
    method: 'post',
    data: apidata,
    responseType: 'blob',
  })
